import React, { Component } from 'react'
import ReactSVG from 'react-svg'

export default class SvgIcon extends Component {
  state = {}
  render() {
    return (
      <ReactSVG
        path={this.props.path}
        evalScripts="always"
        onInjected={(svg) => {
        }}
        svgClassName={this.props.svgClassName}
        svgStyle={this.props.style}
        className={this.props.className}
        onClick={() => {
        }}
      />
    )
  }
}
